import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './configs/authConfig';

// Older versions stored the access token in localStorage; it is only kept in memory now.
localStorage.removeItem('token');

createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>
    </React.StrictMode>,
);
